import { render, staticRenderFns } from "./LatestInvestorRisksContract.vue?vue&type=template&id=573ee821&"
import script from "./LatestInvestorRisksContract.vue?vue&type=script&lang=js&"
export * from "./LatestInvestorRisksContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports